import script from "./UserMailRenewal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMailRenewal.vue?vue&type=script&setup=true&lang=js"

import "./UserMailRenewal.vue?vue&type=style&index=0&id=7770124c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7770124c"]])

export default __exports__